import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = { scheduled: "Envoi programmé", sending: "En cours d'envoi", sent: "Envoyé", claimed: "Ouvert par votre proche" };

export const MyGifts = () => {
  const [gifts, setGifts] = useState([]);
  useEffect(() => {
    api.get("/me/gifts").then((r) => setGifts(r.data || [])).catch(() => setGifts([]));
  }, []);
  if (!gifts.length) return null;
  return (
    <section className="mt-8 rounded-2xl bg-white border border-[#E8DCC4] p-5" data-testid="my-gifts">
      <p className="font-serif text-lg text-[#1F2A24] inline-flex items-center gap-2"><Gift size={18} className="text-[#C9A24B]" /> Mes cadeaux offerts</p>
      <ul className="mt-3 divide-y divide-[#E8DCC4]">
        {gifts.map((g) => (
          <li key={g.txn_id} className="py-2.5 flex flex-wrap justify-between gap-2 font-sans text-sm" data-testid={`my-gift-${g.order_number}`}>
            <span>Coffret Découverte pour <strong>{g.recipient_name || g.recipient_email}</strong> · {new Date(g.send_date).toLocaleDateString("fr-FR")}</span>
            <span className="text-[#385E3A]">{STATUS[g.status] || g.status}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};
